var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message.valid)?_c('b-form-invalid-feedback',{attrs:{"state":!_vm.message.valid}},[_vm._v(" "+_vm._s(_vm.message.content)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }